"use client";
import { registerNavigationMarker } from "./navigation-readiness";

type Props = {
  readonly status?: "ready" | "error";
} & (
  | {
      readonly stage: "shell";
      readonly path?: never;
      readonly hydrated?: never;
    }
  | {
      readonly stage: "personal";
      readonly path: string;
      readonly hydrated?: never;
    }
  | {
      readonly stage: "content";
      readonly path: string;
      readonly hydrated?: boolean;
    }
);

export function NavigationReady({
  stage,
  path,
  status = "ready",
  hydrated = stage !== "content",
}: Props) {
  return (
    <span
      ref={(marker) => (marker ? registerNavigationMarker(marker) : undefined)}
      hidden
      data-navigation-ready={stage}
      data-navigation-status={status}
      data-navigation-mode={hydrated ? "hydrated" : "html"}
      data-navigation-path={path?.split(/[?#]/, 1)[0]}
    />
  );
}
